import React, { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getTenderList, tenderSearch, deleteTender } from "../../../redux/actions/TenderActions"
import { CircularProgress } from '@material-ui/core';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import moment from 'moment';
import 'moment/locale/fr';


let TendersListing = (props) => {
    const { tenderSearch, storeTender = {}, getTenderList, deleteTender } = props;
    const [isLoading, setIsLoading] = React.useState(true);
    // const [tenderSearchResult, setTenderSearchResult] = React.useState(null);
    // const [displayingTenderList, setDisplayingTenderList] = React.useState([]);
    // const [filterValues, setFilterValues] = React.useState([]);
    const [tenderList, setTenderList] = React.useState([]);
    const [initialTenderList, setInitialTenderList] = React.useState([]);
    const closeDeleteTedersModal = React.useRef();
    const [isDeletting, setIsDeletting] = React.useState(false);
    const [tenderTodelete, setTenderTodelete] = React.useState(null);



    // useEffect(() => {
    //     if (tenderSearchResult != null && isLoading == true) {
    //         setIsLoading(false);
    //     }
    //     if (Object.keys(storeTender.tenderSearchResult).length != 0 && storeTender.tenderSearchResult.constructor == Object && tenderSearchResult == null) {
    //         setTenderSearchResult(storeTender.tenderSearchResult);
    //         setDisplayingTenderList(storeTender.tenderSearchResult.documents);
    //     }
    // }, [tenderSearchResult]);

    useEffect(() => {
        if (tenderList.length == 0 && storeTender.tenderList.length == 0) {
            getTenderList(true).then(resp => {
                if (resp.success) {
                    setTenderList(resp.tendersList);
                    setInitialTenderList(resp.tendersList);
                    setIsLoading(false);
                }
            });
        }
        else if (tenderList.length == 0 && storeTender.tenderList.length > 0) {
            setTenderList(storeTender.tenderList);
            setInitialTenderList(storeTender.tenderList);
            setIsLoading(false);
        }
    }, []);

    // const checkboxHandleChange = (event) => {
    //     if (event.target.checked) {
    //         let filterValuesCopy = filterValues;
    //         filterValuesCopy.push(event.target.value);
    //         setFilterValues(filterValuesCopy)
    //         let documents = tenderSearchResult.documents;
    //         let result = [];
    //         filterValues.forEach(element => {
    //             let tenders = documents.filter(doc => doc.category == element);
    //             if (tenders != null) {
    //                 result = result.concat(tenders);
    //             }
    //         });
    //         setDisplayingTenderList(result);

    //     }
    //     else {
    //         let values = filterValues.filter(item => item != event.target.value);
    //         let documents = tenderSearchResult.documents;
    //         let result = [];
    //         if (filterValues.length > 0) {
    //             filterValues.forEach(element => {
    //                 let tenders = documents.filter(doc => doc.category == element);
    //                 if (tenders != null) {
    //                     result = result.concat(tenders);
    //                 }
    //             });
    //         }
    //         else {
    //             result = documents;
    //         }
    //         setDisplayingTenderList(result);
    //     }
    // }

    const handleDeleteSubmit = () => {
        setIsDeletting(true);
        deleteTender(tenderTodelete.id).then(resp => {
            setTenderList(resp.tendersList);
            setInitialTenderList(resp.tendersList);
            setTenderTodelete(undefined);
            closeDeleteTedersModal.current.click();
            setIsDeletting(false);
        });
    }

    const handleSearchBoxChange = (event) => {
        let searchTerm = event.target.value;
        let filteredData = initialTenderList.filter(value => {
            return (
                value.tenderNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                value.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                value.employer?.companyName?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        });
        setTenderList(filteredData);
    }

    return (
        <React.Fragment>
            <Helmet>
                <title> Administration | Appel d'offres   | Malibaara</title>
            </Helmet>
            {isLoading ? (
                <div className="row bg-white pt-4 mt-lg-0">
                    <div className="col-lg-12">
                        <div className="loading-container bg-white">
                            <CircularProgress />
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <div className="row bg-white pt-4 mt-lg-0">
                        <div className="col-lg-12 mt-4 mt-lg-0">
                            <div className="row mb-4">
                                <div className="col-md-7 col-sm-5 d-flex align-items-center">
                                    <div className="section-title-02 mb-0 ">
                                        <h4 className="mb-0" style={{ marginLeft: "10px" }}>{tenderList.length} Appel d'offres</h4>
                                    </div>
                                </div>
                                <div className="col-md-5 col-sm-7 mt-3 mt-sm-0">
                                    <div className="search">
                                        <i className="fas fa-search"></i>
                                        <input type="text" className="form-control" placeholder="Rechercher..." onChange={handleSearchBoxChange} />
                                    </div>
                                </div>
                            </div>
                            <table className="table table-striped" id="table"
                                data-toggle="table"
                                data-height="460"
                                data-pagination="true"
                                data-pagination-h-align="left"
                                data-pagination-detail-h-align="right">
                                <thead>
                                    <tr>
                                        <th scope="col" style={{ width: "10%" }}>Numéro</th>
                                        <th scope="col" style={{ width: "45%" }}>Titre</th>
                                        <th scope="col" style={{ width: "25%" }}>Employeur</th>
                                        <th scope="col" style={{ width: "15%" }}>Date</th>
                                        <th scope="col" style={{ width: "5%" }}>Statut</th>
                                        <th scope="col" style={{ width: "5%" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tenderList.map((tender, index) => (
                                        <tr key={index}>
                                            <td>{tender.tenderNumber}</td>
                                            <td>
                                                {tender.title}
                                            </td>
                                            <td>
                                                {tender.employer?.companyName}
                                            </td>
                                            <td>
                                                {moment(tender.postedDate).format('Do MMMM YYYY')}
                                            </td>
                                            <td>
                                                {tender.isActive ? (<div className="active">Actif</div>) : (<div className="inactive">Inactif</div>)}
                                            </td>
                                            <td>
                                                <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                                    <li><Link to={"/admin/tender/details/" + tender.id}><i className="fas fa-pencil-alt"></i></Link></li>
                                                    <li><a href="assets/#" className="text-danger" data-toggle="modal" title="" data-target="#deleteTender" data-original-title="Delete"><i className="far fa-trash-alt" onClick={() => setTenderTodelete(tender)}></i></a></li>
                                                </ul>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Start Delete user modale */}
                    <div className="modal fade" id="deleteTender" tabIndex="-1" role="dialog" aria-modal="true">
                        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header p-4">
                                    <h4 className="mb-0 text-center">Suppression d'un appel offre: {tenderTodelete?.title}</h4>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form className="mt-2">
                                    <div className="modal-body">
                                        <div>
                                            <div className="form-row">
                                                <p>Voulez vous supprimer cette offre?</p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-dismiss="modal"
                                            ref={closeDeleteTedersModal}
                                        >
                                            NON
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={handleDeleteSubmit}
                                            disabled={isDeletting}
                                        >
                                            OUI &nbsp; {isDeletting ? <CircularProgress size={15} /> : <span></span>}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {/* End Delete user modale */}
                </>
            )
            }
        </React.Fragment >
    );

}
TendersListing.propTypes = {
    tenderSearch: PropTypes.func.isRequired,
    getTenderList: PropTypes.func.isRequired,
    storeTender: PropTypes.object.isRequired,
    deleteTender: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    tenderSearch: PropTypes.func.isRequired,
    getTenderList: PropTypes.func.isRequired,
    storeTender: state.tender,
    deleteTender: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, { tenderSearch, getTenderList, deleteTender })(TendersListing)